import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { NgxSmartModalService } from 'ngx-smart-modal';

import { ButtonComponent } from '../../../components/button/button.component';
import { ReceiptType, TableService } from '../../../domain/services/table.service';

@Component({
    selector: 'app-receipt',
    imports: [
        CommonModule,
        ButtonComponent,
    ],
    templateUrl: './receipt.component.html',
    styleUrl: './receipt.component.scss'
})
export class ReceiptComponent {

  constructor(
    private ngxSmartModalService: NgxSmartModalService,
    private tableService: TableService,
  ) {}

  handleClose(closeType: ReceiptType) {
    this.tableService.setReceiptType(closeType)
    this.ngxSmartModalService.setModalData({ closeType }, 'show-receipts');
    this.ngxSmartModalService.getModal('show-receipts').close()
  }
}
